import { baseRoutes } from "helpers/baseRoutes";

/**
 * Define access routes related to user management, including paths and icons using baseRoutes from the "helpers/baseRoutes" module.
 * @constant {Object} accessRoute
 */
const accessRoute = {
  MANAGELINK: {
    path: `${baseRoutes.adminBaseRoutes}/notification-link`,
    icon: (
      <span className="nk-menu-icon">
        <em className="icon ni ni-file-docs" />
      </span>
    ),
  },
};

export default accessRoute;
